import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  IBulkImportResponse,
  IBulkImportRow,
} from "@/interface/bulkImport.interface";
import type {
  CreateSalaryHeadPayload,
  IBranchWiseSalaryHeadResponse,
  ICreateSalaryHeadResponce,
  IUpdateUserSalaryResponse,
  SalaryHeadResponse,
  UpdateUserSalary,
} from "@/interface/salaryHead.interface";

export const SalaryHeadServices = {
  create: async (
    payload: CreateSalaryHeadPayload,
  ): Promise<ICreateSalaryHeadResponce> => {
    return callApi<ICreateSalaryHeadResponce>(API_ENDPOINT.salaryHead, {
      method: "POST",
      data: payload,
    });
  },

  getList: async (queryString: string): Promise<SalaryHeadResponse> => {
    const url = `${API_ENDPOINT.salaryHead}?${queryString}`;
    return callApi<SalaryHeadResponse>(url, {
      method: "GET",
    });
  },

  getById: async (id: string): Promise<ICreateSalaryHeadResponce> => {
    const url = `${API_ENDPOINT.salaryHead}/${id}`;
    return callApi<ICreateSalaryHeadResponce>(url, {
      method: "GET",
    });
  },

  update: async (
    id: string,
    payload: CreateSalaryHeadPayload,
  ): Promise<ICreateSalaryHeadResponce> => {
    const url = `${API_ENDPOINT.salaryHead}/${id}`;
    return callApi<ICreateSalaryHeadResponce>(url, {
      method: "PUT",
      data: payload,
    });
  },

  delete: async (id: string): Promise<ICreateSalaryHeadResponce> => {
    const url = `/salary-head/${id}`;
    return callApi<ICreateSalaryHeadResponce>(url, {
      method: "DELETE",
    });
  },

  getBranchSalaryHeads: async (branchId: string): Promise<any> => {
    const url = `${API_ENDPOINT.branchSalaryHead}?pageNumber=1&pageSize=1000&branchId=${branchId}`;
    return callApi(url, {
      method: "GET",
    });
  },

  createBranchSalaryHead: async (payload: {
    branchId: string;
    salaryHeadId: string;
    isFixed: boolean;
    amount: string;
  }): Promise<any> => {
    const url = API_ENDPOINT.branchSalaryHead;
    return callApi(url, {
      method: "POST",
      data: payload,
    });
  },

  updateBranchSalaryHead: async (
    id: string,
    payload: {
      branchId: string;
      salaryHeadId: string;
      isFixed: boolean;
      amount: string;
    },
  ): Promise<any> => {
    const url = `${API_ENDPOINT.branchSalaryHead}/${id}`;
    return callApi(url, {
      method: "PUT",
      data: payload,
    });
  },

  deleteBranchSalaryHead: async (id: string): Promise<any> => {
    const url = `${API_ENDPOINT.branchSalaryHead}/${id}`;
    return callApi(url, {
      method: "DELETE",
    });
  },

  BranchSalaryHeadTemplate: async (payload: {
    branchId: string;
    userIds: string[];
  }): Promise<Blob> => {
    const url = `${API_ENDPOINT.BranchSalaryHeadTemplates}`;
    return callApi(url, {
      method: "POST",
      data: payload,
    });
  },

  branchWiseSalaryImport: async (
    payload: FormData | { rows: IBulkImportRow[] } | IBulkImportRow[],
    params?: string,
  ): Promise<IBulkImportResponse> => {
    const url = `${API_ENDPOINT.branchWiseSalaryImport}${params ? `?${params}` : ""}`;
    const isFormData = payload instanceof FormData;
    return callApi<IBulkImportResponse>(url, {
      method: "POST",
      data: isFormData
        ? payload
        : Array.isArray(payload)
          ? { rows: payload }
          : payload,
      multipart: true,
    });
  },

  getBranchWiseUserSalary: async (params: string): Promise<any> => {
    const url = `${API_ENDPOINT.branchWiseUserSalary}?${params}`;
    return callApi(url, { method: "GET" });
  },

  updateUserSalary: async (
    payload: UpdateUserSalary,
    userId: string,
  ): Promise<IUpdateUserSalaryResponse> => {
    const url = `${API_ENDPOINT.userSalary}/?userId=${userId}`;
    return callApi<IUpdateUserSalaryResponse>(url, {
      method: "POST",
      data: payload,
    });
  },

  getBranchWiseSalaryHead: async (
    params: string,
  ): Promise<IBranchWiseSalaryHeadResponse> => {
    const url = `${API_ENDPOINT.branchSalaryHead}?${params}`;
    return callApi<IBranchWiseSalaryHeadResponse>(url, { method: "GET" });
  },
};
